module.exports = __webpack_public_path__ + "static/Fellix-Medium-c8063dd89cd6c726271a44293d12e4ce.eot";